import React, { useEffect } from 'react'
import projectsText from '../assets/projectsText.svg'
import projectsmoji from '../assets/projectsmoji.svg'

import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import ProjectCard from './ProjectCard'

import projectCardDetails from '../constants'

const Projects = () => {

    const [ref, inView] = useInView({ triggerOnce: true, });
    const [ref2, inView2] = useInView({ triggerOnce: true, rootMargin: '-300px 0px 0px 0px' });
    const animation = useAnimation();
    const animation2 = useAnimation();

    useEffect(() => {
        if (inView) {
            animation.start({
                opacity: 1, transition: { duration: 2 }
            })
        }
        if (!inView) {
            animation.start({
                opacity: 0
            })
        }
    }, [inView]);

    useEffect(() => {
        if (inView2) {
            animation2.start({
                opacity: 1, transition: { duration: 2, delay: 0.5 }
            })
        }
        if (!inView2) {
            animation2.start({
                opacity: 0
            })
        }
    }, [inView2]);

    return (
        <div name="projects" className='w-full lg:rounded-b-3xl bg-[#121316] px-4 text-gray-200 pb-40'>
            <div className='w-full max-w-6xl mx-auto'>
                <div className='relative w-full'>
                    <motion.div ref={ref} animate={animation}>
                        <img src={projectsText} alt='skill-text' className='mx-auto' />
                        <div className='absolute w-full top-4 sm:top-8 md:top-12 lg:top-20'>
                            <img src={projectsmoji} alt='skill-moji' className='mx-auto w-60 sm:w-72 md:w-80' />
                        </div>
                    </motion.div>
                    <motion.div ref={ref2} animate={animation2} className='grid w-full gap-8 pt-52 md:grid-cols-2 lg:grid-cols-3'>
                        {projectCardDetails.map((item, index) => (
                            <ProjectCard key={index} img={item.img} skills={item.skills} name={item.name} desc={item.desc} link={item.link} />
                        ))}
                    </motion.div>
                </div>
            </div>
        </div>
    )
}

export default Projects